export enum ViewMode {
    LIST = 'list',
    TABLE = 'table',
    CHART = 'chart'
}
